import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { login, getBusinessProfile } from '../services/api';
import Toast from '../components/Toast/Toast';
import { useToast } from '../hooks/useToast';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const { toasts, hideToast, success, error } = useToast();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const { data } = await login({ email, password });
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      
      success('Login successful! Redirecting...');
      
      // Check if business profile exists
      setTimeout(async () => {
        try {
          await getBusinessProfile();
          // Profile exists, go to managers
          navigate('/managers');
        } catch (err) {
          // No profile, go to business profile setup
          navigate('/business-profile');
        }
      }, 1000);
    } catch (err) {
      error(err.response?.data?.error || 'Login failed');
    }
  };

  return (
    <div className="container" style={{ 
      maxWidth: '400px', 
      marginTop: '100px',
      padding: '20px'
    }}>
      <div className="card" style={{
        padding: window.innerWidth <= 480 ? '20px' : '28px'
      }}>
        <h2 style={{ 
          marginBottom: '24px', 
          textAlign: 'center',
          fontSize: window.innerWidth <= 480 ? '22px' : '28px'
        }}>Login</h2>
        <form onSubmit={handleLogin}>
          <label>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit" className="btn btn-primary" style={{ width: '100%' }}>
            Login
          </button>
        </form>
        <p style={{ 
          textAlign: 'center', 
          marginTop: '16px',
          fontSize: window.innerWidth <= 480 ? '13px' : '15px'
        }}>
          Account nahi hai? <Link to="/signup">Signup karein</Link>
        </p>
      </div>

      {/* Toast Notifications */}
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          duration={toast.duration}
          onClose={() => hideToast(toast.id)}
        />
      ))}
    </div>
  );
}

export default Login;
